import React from "react";
import ArticleCard from "./articleCard";
import { Link } from "react-router-dom";
import Loader from "./loader";
import { slugToCountryPathname } from "../../utils/strings";
import { usePosts } from "../../hooks/useCms";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";

function NewPopularArticles({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const selectedPosts = (content.blogEntry?.slice(0, 3) || []).map(({ blog_post }) => blog_post);
  const recentPosts = usePosts({ limit: 3, tag: content.filterTag || undefined });

  if (content?.blogEntry.length < 3 && !recentPosts) return <Loader withMargins />;

  const posts = [...selectedPosts, ...(recentPosts || [])];

  const settings = {
    infinite: true,
    speed: 500,
    fade: false,
    autoplaySpeed: 6000,
    autoplay: true,
    dots: true,
    draggable: isMobile ? true : false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: 0,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)"
  };

  return posts.length ? (
    <div className="newPopularArticles">
      <div className="title">{content.title}</div>
      <div className="subtitle">{content.subtitle}</div>
      {isMobile ? (
        <div className="slider">
          <Slider {...settings}>
            {posts.length && posts.slice(0, 3).map((post, i) => <ArticleCard key={i} content={post} />)}
          </Slider>
        </div>
      ) : (
        <div className="main">
          {posts.length && posts.slice(0, 3).map((post, i) => <ArticleCard key={i} content={post} />)}
        </div>
      )}
      <Link to={slugToCountryPathname("blog")} className="moreArticles">
        <span>More Articles</span>
      </Link>
    </div>
  ) : null;
}

function NewPopularArticlesV4({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 1100px)" });
  const selectedPosts = (content.blogEntry?.slice(0, 4) || []).map(({ blog_post }) => blog_post);
  const recentPosts = usePosts({ limit: 4, tag: content.filterTag || undefined });

  if (content?.blogEntry.length < 3 && !recentPosts) return <Loader withMargins />;

  const posts = [...selectedPosts, ...(recentPosts || [])];

  const settings = {
    arrows: !!isTablet,
    infinite: true,
    speed: 500,
    autoplaySpeed: 6000,
    autoplay: true,
    dots: false,
    draggable: !!isTablet,
    slidesToShow: isMobile ? 1.2 : isTablet ? 2 : 1,
    slidesToScroll: 1,
    centerMode: !!isTablet,
    centerPadding: isTablet ? 0 : undefined,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    variableWidth: isTablet ? true : undefined
  };

  return posts.length ? (
    <div className="newPopularArticlesV4">
      <div className="title">{isMobile ? content.titleMobile : content.title}</div>
      <div className="subtitle">{content.subtitle}</div>
      {isMobile ? (
        <div className="slider">
          <Slider {...settings}>
            {posts.length && posts.slice(0, 4).map((post, i) => <ArticleCard key={i} content={post} />)}
          </Slider>
        </div>
      ) : (
        <div className="main">
          {posts.length && posts.slice(0, 4).map((post, i) => <ArticleCard key={i} content={post} />)}
        </div>
      )}
      <Link to={slugToCountryPathname("blog")} className={`moreArticles ${isTablet ? "mobile" : ""}`}>
        <span>More Articles</span>
      </Link>
    </div>
  ) : null;
}

let temp = process.env.REACT_APP_V4_ENABLE === "true" ? NewPopularArticlesV4 : NewPopularArticles;
export default temp;
